import React from "react";
import { Td, Tr } from "@chakra-ui/react";
import "../styleBox.css";

const bold = { fontWeight: "bold" };

// Totals row for Desperdicios: show quantity total by unit in columns
// Cantidad (col 3) and Unidad (col 4), keep other columns empty
const TbodyGarbageUnit = ({ data }) => {
  return (
    <Tr>
      <Td className="text-center">{}</Td>
      <Td className="text-center">{}</Td>
      <Td isNumeric style={bold} className="total_unit-styles">
        {data?.total_unit}
      </Td>
      <Td className="text-center" style={bold}>
        {data?.unit}
      </Td>
      <Td className="text-center">{}</Td>
      <Td className="text-center">{}</Td>
      <Td className="text-center">{}</Td>
    </Tr>
  );
};

export default TbodyGarbageUnit;
